// removed by extract-text-webpack-plugin
module.exports = {"base":"Reward_base--1YEGN","description":"Reward_description--2FsJI","reservesCount":"Reward_reservesCount--3Cyi3","reservesLevel":"Reward_reservesLevel--1Z_MH","reservesList":"Reward_reservesList--2gfXl","reserveItem":"Reward_reserveItem--3UmlN"};


//////////////////
// WEBPACK FOOTER
// ./containers/CommandCenterCard/components/Reward/Reward.scss
// module id = 2148
// module chunks = 11